export default __webpack_public_path__ + "static/media/circleCloud7.a23ef5ec.webp";